var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSzambelanInformacjeObjasnienia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 240,
    height: 240,
    viewBox: "0 0 240 240",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M123.852 84.672c2.595 2.351 4.037 5.723 3.926 9.184-.11 3.46-1.73 6.7-4.437 8.873l-22.383 17.902a16.495 16.495 0 0 1-10.338 3.638H1.775A1.78 1.78 0 0 1 0 122.495v-3.55a1.78 1.78 0 0 1 1.775-1.774H90.62a9.43 9.43 0 0 0 5.924-2.063l22.36-17.903a4.715 4.715 0 0 0 .2-7.232 4.542 4.542 0 0 0-3.061-1.153c-1.131 0-2.307.4-3.239 1.153L99.14 100.888a9.563 9.563 0 0 1-5.923 2.063H53.24a3.56 3.56 0 0 1-3.55-3.55 3.56 3.56 0 0 1 3.55-3.549h19.522a5.311 5.311 0 0 0 5.324-5.324 5.311 5.311 0 0 0-5.324-5.324H40.219c-3.061 0-6.056.998-8.518 2.84l-10.405 7.808H1.775A1.78 1.78 0 0 1 0 94.077v-3.549a1.78 1.78 0 0 1 1.775-1.775h17.148l8.518-6.389a21.22 21.22 0 0 1 12.778-4.259H72.23c6.256 0 11.935 4.393 12.822 10.582.377 2.573-.044 5.035-1.064 7.165h9.228c.555 0 1.065-.177 1.486-.51l13.665-10.937a12.27 12.27 0 0 1 7.676-2.706c2.906 0 5.679 1.065 7.809 2.973zm-67.594-21.36h2.58V37.505h-2.58a2.58 2.58 0 0 1-2.58-2.58v-1.72a2.58 2.58 0 0 1 2.58-2.581h10.323a2.58 2.58 0 0 1 2.58 2.58v30.108h2.58a2.58 2.58 0 0 1 2.582 2.58v1.72a2.58 2.58 0 0 1-2.581 2.582H56.258a2.58 2.58 0 0 1-2.58-2.581v-1.72a2.58 2.58 0 0 1 2.58-2.581zM64 11.699a6.882 6.882 0 1 1 0 13.763A6.882 6.882 0 0 1 64 11.7z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(4 4)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 116,
    cy: 116,
    r: 116,
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    stroke: "#979797",
    strokeWidth: 8,
    d: "M0 116c0 64.065 51.935 116 116 116s116-51.935 116-116S180.065 0 116 0"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.383,
    transform: "translate(52 52)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    fillRule: "nonzero",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillOpacity: 0.38,
    fillRule: "nonzero",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h128v128H0z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSzambelanInformacjeObjasnienia);
export default __webpack_public_path__ + "static/media/szambelan_informacje_objasnienia.8a02732016b8f02c10b8dbf2241bd483.svg";
export { ForwardRef as ReactComponent };